import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    address: {
        maxWidth: 300,
        padding: theme.spacing(2),
        marginTop: theme.spacing(3),
        backgroundColor: theme.palette.background.dark,
        marginBottom: theme.spacing(6 / 8),
        borderRadius: theme.shape.borderRadius,
    },
    changeAddressLink: {
        fontWeight: theme.typography.fontWeightBold,
        textDecoration: "underline",
        cursor: "pointer",
    },
}));
